<template>
   <div id="container">
      <mvtHeader />
      <div class="mls-logos">
                <h2>Disclaimers</h2>
                <div class="mlslogoList">
                  <template v-for="(id,index) in logoIdList" :key="index" >
                        <div class="logo-details" v-if="!mlsData.data[id].rentals">
                              <div class="logo">
                                    <div class="logo-img">
                                          <img class="img-mlslogo" v-if="id==461 && logos.indexOf(parseInt(id)) >=0" :src="imgUrl + id + '_large.png'" :alt="id">
                                          <img class="img-mlslogo" v-else-if="logos.indexOf(parseInt(id)) >=0" :src="imgUrl + id + '.png'" :alt="id">
                                          <img class="img-mlslogo" v-if="isMLSGridLogo(parseInt(id))" :src="imgUrl + 'mlsgrid.png'" :alt="id">
                                    </div>
                                    <div class="logo-info">
                                          <div class="title">{{mlsData.data[id].name}}</div>
                                          <div class="description" v-html="mlsData.data[id].desc"></div>
                                    </div>
                              </div>
                        </div>
                  </template>
                </div>
            </div>
      <mvtFooter />
      <mvtDialogCenter></mvtDialogCenter>
   </div>
</template>
<script src="./mlslogo.js"></script>
<style lang="scss">
@use './mlslogo.scss' as *;
</style>
